import { Card, Container, Stack, Typography, useTheme } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';

import { FullPageSpinner, Markdown } from '@zeta-core';
import { InvestorService } from '@zeta-services';
import { IViewFactFindRequest } from '@zeta-types';
import { ClientSummaryPieIcon } from '@zeta-core/assets';

const Summary = ({ clientID }: { clientID: string }) => {
  const theme = useTheme();

  const { mutateAsync, data, isPending } = useMutation({
    mutationFn: (payload: IViewFactFindRequest) => InvestorService().viewClientSummary(payload),
  });

  useEffect(() => {
    mutateAsync({ clientID: clientID });
  }, [mutateAsync]);

  const summaryData = data?.data?.response?.reportSummaryRequest;

  return (
    <Card sx={{ p: 1.5, marginBottom: 20, background: theme.palette.grey[100] }}>
      <Stack gap={3}>
        {isPending ? (
          <FullPageSpinner />
        ) : (
          <Stack gap={2}>
            {summaryData?.clientCurrentSituation?.[0] ? (
              <>
                <Markdown children={summaryData?.clientCurrentSituation?.[0] ?? ''} />
                {summaryData?.businessInterest?.[0] && <Markdown children={summaryData?.businessInterest[0] ?? ''} />}
                {summaryData?.trust?.[0] && <Markdown children={summaryData?.trust[0] ?? ''} />}
              </>
            ) : (
              <Container
                maxWidth="md"
                sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 240px)', display: 'flex', gap: 3 }}
              >
                <ClientSummaryPieIcon />
                <Typography variant="subtitle2">
                  This section provides a comprehensive summary of your clients' financial profiles, dynamically updating as data flows from multiple sources.
                  Stay informed with real-time insights as key financial details are gathered across integrated channels. Ensure seamless fact-finding by
                  tracking evolving client information for more accurate and strategic financial planning.
                </Typography>
              </Container>
            )}
          </Stack>
        )}
      </Stack>
    </Card>
  );
};

export default Summary;
